var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"id":"modal_div"}},[_c('span',{attrs:{"id":"close-modal","onclick":"document.getElementById('modal_div').style.display='none'"}},[_vm._v("×")]),_c('img',{staticClass:"modal-content",attrs:{"id":"modal_image"}})])
}]

export { render, staticRenderFns }